<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <Header
        :lingronCounter="lingronCounter"
        :stepCounter="stepCounter"
        :maxLingron="maxLingron"
        fromStepField="false"
      />

      <v-flex xs12 d-flex text-xs-center class="questionTitle">
        <h3>
          Hallgasd meg a felvételt és kattintsd össze a mondatot

          <!-- <v-btn 
            v-if="question.lesson_id === 4" 
            color="info" 
            fab 
            small 
            @click="tipp.show = true"
            >

            <v-icon>info</v-icon>
          </v-btn> -->
        </h3>
      </v-flex>

      <v-flex xs12 class="text-xs-center ">
        <img
          v-show="!voiceShow"
          :src="require('@/assets/img/voice_muted.gif')"
          alt="voice_muted"
          height="100px"
        />
        <img
          v-show="voiceShow"
          :src="require('@/assets/img/voice.gif')"
          alt="voice"
          height="100px"
        />
      </v-flex>

      <v-flex xs12 d-flex text-xs-center style="margin-top: -0px;">
        <v-layout row wrap>
          <v-flex xs12 text-xs-center>
            <transition name="glide">
              <div v-show="showStepEffect" style="height: 0px;">
                <img
                  :src="require('@/assets/img/footprint_mod_2.png')"
                  height="75px"
                />
              </div>
            </transition>
          </v-flex>

          <v-flex
            v-for="(file, index) in files"
            :key="index"
            :class="getSoundFileIcon(index, file, files)"
          >
            <!-- <div v-bind:class="getSoundFileButton(index, file)" @click="playSound(file)"/> -->
            <img
              :src="getSoundFileImage(index, file)"
              alt="index"
              width="25px"
              class="playButtonImage"
            />
            <v-btn
              color="#0672e5"
              fab
              large
              class="text-light"
              @click="playSound(file)"
            >
              <v-icon large>volume_up</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs12>
            <v-layout row v-if="words.length > 0">
              <v-flex v-for="(word, index) in words" :key="index">
                <transition name="fadeFast">
                  <v-card
                    :id="index"
                    :class="{ cardActive: word.focus }"
                    v-show="!nextStep"
                  >
                    <div class="emptyWord words minHeight">
                      <span v-show="word.show">{{ word.other_lang }}</span>
                    </div>
                  </v-card>
                </transition>
              </v-flex>
            </v-layout>
          </v-flex>

          <transition name="fadeSlow">
            <v-flex xs12 md6 offset-md3 v-show="nextStep">
              <v-card
                dark
                class="cardSuccess text-center align-center"
                color="#0672e5"
              >
                <div class="wordsQuestion">{{ question.title }}</div>
              </v-card>
            </v-flex>
          </transition>

          <transition name="fadeSlow">
            <v-flex xs12 md6 offset-md3 class v-show="nextStep">
              <v-card dark class="cardActive align-center" color="#421773">
                <div class="wordsQuestion">{{ question.sentence }}</div>
              </v-card>
            </v-flex>
          </transition>

          <transition name="fadeFast">
            <v-flex xs12 v-show="showRandomWords">
              <v-layout row v-if="question.words !== undefined">
                <v-flex v-for="(word, index) in randomWords" :key="index">
                  <!-- <transition name=rotate> -->
                  <v-card
                    :id="word.id"
                    class="randomWord"
                    @click="pairWord(word)"
                    v-bind:class="{ cardWrong: word.error }"
                  >
                    <div
                      class="words randomWordContent"
                      :class="{ cardDisabled: word.disabled }"
                    >
                      {{ word.other_lang }}
                    </div>
                  </v-card>
                  <!-- </transition> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </transition>

          <v-spacer></v-spacer>

          <v-flex
            xs12
            class="mt-md-5 pt-md-5 align-self-center text-centernavigation"
          >
            <v-divider></v-divider>

            <v-layout row wrap v-bind:class="{ bgPurple: nextStep }">
              <v-flex xs12 v-if="nextStep" @click="goToLingrons">
                <v-btn large dark flat>
                  Következő
                  <v-icon right dark>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs12 v-else>
                <v-btn large disabled>
                  Következő
                  <v-icon right dark>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="tipp.show" width="600">
      <v-card>
        <v-card-title class="headline mainBlue dark text-light">
          Kérdések

          <v-spacer></v-spacer>

          <v-btn color="error" fab small @click="tipp.show = false">
            <v-icon class="text-light">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text @click="tipp.show = false">
          <p>
            Egy igazi LINGO SKILLER (csúcs-nyelvhasználó) hallás után gyakorol.
            <br />
            Nálunk minden egyes meghallgatott anyag egy lépésnek számít a cél
            felé. <br />
            Ezt jelképezi a lábnyom, amit itt látsz. <br />
            A lecke új mondataival mindig HALLÁS UTÁN, egy könnyű kirakós
            feladaton keresztül ismerkedsz meg. <br />
            Egy leckében 3-4 mondattal gyakorlunk. <br />
            A lecke további részében ezeket a mondatokat bontjuk apróbb
            részekre.
          </p>
        </v-card-text>

        <v-card-actions class="text-xs-center">
          <v-layout row wrap>
            <v-flex xs12 text-xs-center>
              <v-btn color="error" dark @click="tipp.show = false">
                Bezár
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";
import Header from "@/components/partials/Header";

export default {
  components: {
    Header
  },
  data: function() {
    return {
      lessonId: this.$route.params.lessonId,
      // lessonId: this.$store.getters.currentLessonId,
      playSoundCounter: 0,
      playedNow: false,
      showSentence: false,
      question: "",
      words: "",
      files: "",
      soundFileClass: "",
      soundFile: "",
      randomWords: "",
      showRandomWords: true,
      nextStep: false,
      last: false,
      progressIndicator: 0,
      stepCounter: this.$store.getters.getStepCounter,
      lingronCounter: this.$store.getters.getLingronCounter,
      maxLingron: 0,
      points: 0,
      showStepEffect: false,
      voiceShow: false,
      tipp: {
        show: false
      },
      axiosUrl: this.$store.getters.getApiUrl + "/api/question"
    };
  },
  methods: {
    getLessonData() {
      if (this.$data.isFreeLesson) {
        this.$data.axiosUrl =
          this.$store.getters.getApiUrl + "/api/question/free";
      }

      //DEBUG
      //console.log(this.$data.axiosUrl);

      axios
        .post(this.$data.axiosUrl, {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId,
          lastQuestion: this.$store.getters.getLastQuestion
        })
        .then(response => {
          // console.log("question - resp: ", response.data);

          this.$store.commit("updateLastQuestion", {
            lastQuestionId: response.data.question.id
          });

          this.$store.commit("updateLastQuestionState", {
            lastQuestionState: response.data.last
          });

          this.$store.commit("updateProgressIndicator", {
            progressIndicator: response.data.progressIndicator
          });

          this.$store.commit("setMaxLingron", {
            maxLingron: response.data.maxLingron
          });

          //Remove last lingron for sec reason
          this.$store.commit("updateLastLingron", {
            lastLingronId: null
          });

          //If question disabled in lesson go to lingron
          if (response.data.lessonQuestionDisable) {
            this.$router.push({
              name: "lingron",
              params: {
                lessonId: this.$data.lessonId,
                questionId: response.data.question.id
              }
            });
          }

          //Load main data to question
          this.$data.question = response.data.question;
          this.$data.last = response.data.last;
          this.$data.words = response.data.words;
          this.$data.files = response.data.files;
          this.$data.maxLingron = response.data.maxLingron;
          this.$data.randomWords = response.data.randomWords;
          this.$data.progressIndicator = response.data.progressIndicator;
          this.$data.maxLingron = response.data.maxLingron;
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("question- error: ", error);
          }
        });
    },
    getSoundFileIcon(index, file, files) {
      if (files.length === 1) {
        return "text-xs-center xs12";
      }

      if (files.length === 2) {
        let size = "xs6";

        if (index === 0) {
          return "text-xs-right " + size;
        }
        if (index === 1) {
          return "text-xs-center " + size;
        }
      }

      if (files.length === 3) {
        let size = "xs4";

        if (index === 0) {
          return "text-xs-right " + size;
        }
        if (index === 1) {
          return "text-xs-center " + size;
        }
        if (index === 2) {
          return "text-xs-left " + size;
        }
      }
    },
    getSoundFileImage(index, file) {
      if (index === 0) {
        if (file.locale == "eng") {
          return require("@/assets/img/flag_eng.png");
        }
        if (file.locale == "usa") {
          return require("@/assets/img/flag_usa.png");
        }
        if (file.locale == "sco") {
          return require("@/assets/img/flag_sco.png");
        }
        if (file.locale == "aus") {
          return require("@/assets/img/flag_aus.png");
        }
      }
      if (index === 1 && file !== null && file !== undefined) {
        if (file.locale == "eng") {
          return require("@/assets/img/flag_eng.png");
        }
        if (file.locale == "usa") {
          return require("@/assets/img/flag_usa.png");
        }
        if (file.locale == "sco") {
          return require("@/assets/img/flag_sco.png");
        }
        if (file.locale == "aus") {
          return require("@/assets/img/flag_aus.png");
        }
      }
      if (index === 2 && file !== null) {
        if (file.locale == "eng") {
          return require("@/assets/img/flag_eng.png");
        }
        if (file.locale == "usa") {
          return require("@/assets/img/flag_usa.png");
        }
        if (file.locale == "sco") {
          return require("@/assets/img/flag_sco.png");
        }
        if (file.locale == "aus") {
          return require("@/assets/img/flag_aus.png");
        }
      }
    },
    getSoundFileButton(index, file) {
      //Deprecated
      if (index === 0) {
        if (file.locale == "eng") {
          return "playButton playButtonEng text-right float-right";
        }

        if (file.locale == "usa") {
          return "playButton playButtonUsa text-right float-right";
        }
        if (file.locale == "sco") {
          return "playButton playButtonSco text-right float-right";
        }
      }
      if (index === 1) {
        if (file.locale == "eng") {
          return "playButton playButtonEng text-center float-center";
        }

        if (file.locale == "usa") {
          return "playButton playButtonUsa text-center float-center";
        }
        if (file.locale == "sco") {
          return "playButton playButtonSco text-center float-center";
        }
      }
      if (index === 2) {
        if (file.locale == "eng") {
          return "playButton playButtonEng text-left float-left";
        }

        if (file.locale == "usa") {
          return "playButton playButtonUsa text-left float-left";
        }
        if (file.locale == "sco") {
          return "playButton playButtonSco text-left float-left";
        }
      }
    },
    playSound(file) {
      if (file) {
        //Play the audio file
        let sound =
          this.$store.getters.getApiUrl + "/uploads/sound/" + file.filename;
        var audio = new Audio(sound);

        if (!this.$data.playedNow) {
          this.$data.playedNow = true;
          // this.$data.showStepEffect = true;
          this.$data.voiceShow = true;

          audio.play();

          let v = this;
          // setTimeout(function () {
          //   // v.$data.showStepEffect = false;
          // }, 2000);

          setTimeout(function() {
            v.$data.playedNow = false;
            v.$data.voiceShow = false;

            //Increment the stepCounter
            v.$data.stepCounter++;

            //Store the new stepCounter
            v.$store.commit("updateStepCounter", {
              stepCounter: v.$data.stepCounter
            });
          }, 2700);
        }
      } else {
        // console.log('No file found', sound);
      }
    },
    playWorngEffect() {
      let sound = require("@/assets/sound/wrong_answer.mp3");
      var audio = new Audio(sound);

      audio.play();
    },
    playCorrectEffect() {
      let sound = require("@/assets/sound/correct_answer.mp3");
      var audio = new Audio(sound);
      audio.play();
    },
    randomWordsFunction: function(rand) {
      return rand.sort(function() {
        return 0.5 - Math.random();
      });
    },
    pairWord(word) {
      let focusedWord = this.$data.words.find(item => item.focus === true);

      if (word.other_lang === focusedWord.other_lang) {
        this.$data.words.find(item => item.id === focusedWord.id).show = true;
        this.$data.words.find(item => item.id === focusedWord.id).focus = false;
        this.$data.randomWords.find(
          item => item.id === word.id
        ).disabled = true;
        this.$data.randomWords.find(item => item.id === word.id).error = false;

        if (
          this.$data.words.find(item => item.id === focusedWord.id + 1) !==
          undefined
        ) {
          this.$data.words.find(
            item => item.id === focusedWord.id + 1
          ).focus = true;
        } else {
          this.$data.showRandomWords = false;
          this.$data.nextStep = true;
          this.playCorrectEffect();
        }
      } else {
        this.$data.randomWords.find(item => item.id === word.id).error = true;
        let randomWords = this.$data.randomWords.find(
          item => item.id === word.id
        );
        this.playWorngEffect();

        setTimeout(function() {
          randomWords.error = false;
        }, 2000);

        this.$data.randomWords.find(item => item.id === word.id).error =
          randomWords.error;
      }
    },
    goToLingrons() {
      this.$router.push({
        name: "lingron",
        params: {
          lessonId: this.$data.lessonId,
          questionId: this.$data.question.id
        }
      });
    }
  },
  created: function() {
    this.getLessonData();
  }
};
</script>
